import { render, staticRenderFns } from "./ListaDevoluciones.vue?vue&type=template&id=3742b594&scoped=true"
import script from "./ListaDevoluciones.vue?vue&type=script&lang=js"
export * from "./ListaDevoluciones.vue?vue&type=script&lang=js"
import style0 from "./ListaDevoluciones.vue?vue&type=style&index=0&id=3742b594&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3742b594",
  null
  
)

export default component.exports